var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInactiveIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.684326 1.89474L1.49275 1.10526L7.32222 6.94737L11.5791 11.1916L10.777 12L8.88222 10.1053H1.4738V8.21053C1.4738 7.03579 3.12222 6.26526 4.68854 5.91158L0.684326 1.89474ZM11.5791 8.21053V9.58737L10.3791 8.38737V8.21053C10.3791 8.04632 10.0633 7.8 9.55801 7.57895L7.78959 5.79789C9.50117 6.08211 11.5791 6.89053 11.5791 8.21053ZM2.6738 8.21053V8.90526H7.68222L5.71801 6.94737C4.12012 7.13684 2.6738 7.86316 2.6738 8.21053ZM6.52643 0C7.19645 0 7.83903 0.266165 8.31281 0.739941C8.78658 1.21372 9.05275 1.8563 9.05275 2.52632C9.05275 3.75789 8.16854 4.78737 7.00012 5.00842L4.04433 2.05263C4.15502 1.47534 4.46335 0.954648 4.91633 0.580048C5.36931 0.205449 5.93863 0.000347314 6.52643 0ZM6.52643 1.26316C6.19142 1.26316 5.87013 1.39624 5.63324 1.63313C5.39636 1.87002 5.26327 2.19131 5.26327 2.52632C5.26327 2.86133 5.39636 3.18261 5.63324 3.4195C5.87013 3.65639 6.19142 3.78947 6.52643 3.78947C6.86144 3.78947 7.18273 3.65639 7.41962 3.4195C7.65651 3.18261 7.78959 2.86133 7.78959 2.52632C7.78959 2.19131 7.65651 1.87002 7.41962 1.63313C7.18273 1.39624 6.86144 1.26316 6.52643 1.26316Z",
    fill: "#5E05C6"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveIcon);
export default __webpack_public_path__ + "static/media/inactiveIcon.b186a476e0f7a9912e15f8974c78c8de.svg";
export { ForwardRef as ReactComponent };